// extracted by css-extract-rspack-plugin
export default {"Actions":"RepoHeaderActions-module__Actions__ctPwy"};